/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Lastused3Inputs */

const en_settings_reportingapikeys_column_lastused3 = /** @type {(inputs: Settings_Reportingapikeys_Column_Lastused3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last used`)
};

/**
* | output |
* | --- |
* | "Last used" |
*
* @param {Settings_Reportingapikeys_Column_Lastused3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_lastused3 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Lastused3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Lastused3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_lastused3(inputs)
});
export { settings_reportingapikeys_column_lastused3 as "settings_reportingApiKeys_column_lastUsed" }